import { render, staticRenderFns } from "./Intro5.vue?vue&type=template&id=0c262274&scoped=true&"
import script from "./Intro5.vue?vue&type=script&lang=js&"
export * from "./Intro5.vue?vue&type=script&lang=js&"
import style0 from "./Intro5.vue?vue&type=style&index=0&id=0c262274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c262274",
  null
  
)

export default component.exports